export default __webpack_public_path__ + "static/media/3-como-funciona.1a96598b.png";